import { render, staticRenderFns } from "./DebtShow.vue?vue&type=template&id=64cbcdd1&scoped=true&"
import script from "./DebtShow.vue?vue&type=script&lang=js&"
export * from "./DebtShow.vue?vue&type=script&lang=js&"
import style0 from "./DebtShow.vue?vue&type=style&index=0&id=64cbcdd1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cbcdd1",
  null
  
)

export default component.exports